"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expressCoilTypes = exports.coilTypes = void 0;
exports.coilTypesFor = coilTypesFor;
exports.coilTypes = [
    "fluid",
    "dx",
    "condenser",
    "steam"
];
/**
 * Express walks one input and calculates the rest, and CoilPro offers no sweep for a DX coil or
 * a condenser - so those coil types are not on offer in that mode. The Calculate button used to
 * be a silent no-op for them instead.
 */
exports.expressCoilTypes = ["fluid", "steam"];
function coilTypesFor(mode) {
    return mode === "express-calculate" ? exports.expressCoilTypes : exports.coilTypes;
}
//# sourceMappingURL=types.js.map